async function unlikeWallpaper(wallpaperId: string) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/likes/${wallpaperId}`;

  const res = await fetch(url, { method: "DELETE", credentials: "include" });
  const result: any = await res.json();

  const success = result.success ? true : false;
  return success;
}

export default unlikeWallpaper;
